/* Comissões do captador.

   Três parcelas de R$ 50 por caso:
     captacao  liberada quando a documentação obrigatória fica completa
     saida     liberada quando o benefício é concedido e o dinheiro sai
     bonus     bonificação, a critério do administrador

   A parcela de captação é sugerida automaticamente, mas quem confirma é
   sempre o admin: as policies do Postgres só permitem inserir e editar
   comissão para quem tem papel de admin. Dinheiro não se auto aprova. */

import { sb } from "../supabase.js";
import { S } from "../estado.js";

export const ETAPAS_COMISSAO = [
  { id: "captacao", nome: "Captação",     dica: "documentação completa" },
  { id: "saida",    nome: "Benefício saiu", dica: "dinheiro liberado" },
  { id: "bonus",    nome: "Bonificação",  dica: "caso bem resolvido" }
];
export const VALOR_PADRAO = 50;

/* Comissões de um caso, na ordem das etapas. */
export async function comissoesDoCaso(casoId){
  const { data, error } = await sb
    .from("comissoes")
    .select("id,etapa,valor,pago,pago_em,liberado_em")
    .eq("caso_id", casoId);
  if (error) throw error;
  const mapa = Object.fromEntries((data || []).map(c => [c.etapa, c]));
  return ETAPAS_COMISSAO.map(e => ({ ...e, registro: mapa[e.id] || null }));
}

/* Libera uma parcela. Só admin. */
export async function liberarComissao(casoId, captadorId, etapa, valor = VALOR_PADRAO){
  const { error } = await sb.from("comissoes").insert({
    caso_id: casoId,
    captador_id: captadorId,
    etapa,
    valor,
    liberado_por: S.usuario?.email || ""
  });
  if (error) throw error;
}

export async function removerComissao(id){
  const { error } = await sb.from("comissoes").delete().eq("id", id);
  if (error) throw error;
}

/* Marca como paga (ou desfaz, se pago = false). */
export async function marcarPaga(id, pago = true){
  const { error } = await sb.from("comissoes")
    .update({ pago, pago_em: pago ? new Date().toISOString() : null })
    .eq("id", id);
  if (error) throw error;
}

/* Resumo por captador. O captador vê só a própria linha, por causa do RLS. */
export async function resumoComissoes(){
  const { data, error } = await sb
    .from("resumo_comissoes")
    .select("*")
    .order("total_pendente", { ascending: false });
  if (error) throw error;
  return data || [];
}

/* Lista detalhada, para o fechamento do mês. */
export async function listaComissoes(){
  const { data, error } = await sb
    .from("comissoes")
    .select("id,etapa,valor,pago,pago_em,liberado_em,caso_id,captador_id, casos(cliente)")
    .order("liberado_em", { ascending: false });
  if (error) throw error;
  return data || [];
}

/* Chave PIX de quem está logado, ou de qualquer um se for admin. */
export async function salvarPix(perfilId, pix, tipo){
  const { error } = await sb.from("perfis")
    .update({ pix, pix_tipo: tipo })
    .eq("id", perfilId);
  if (error) throw error;
}

export const dinheiro = v =>
  Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
